import { ApiResListsType } from 'global-services/api/OhsApiModels';
import OhsQrCodeRecord from 'qr-code/models/OhsQrCodeRecord';

const parseListAllocations = (
  qrCodeLists: ApiResListsType<any[]> | null,
  allocationLists: OhsQrCodeRecord[] | null
): ApiResListsType<any[]> | null => {
  const qcList = qrCodeLists?.items ?? [];

  if (qcList.length > 0) {
    const qrCodeWithAllocation = qcList.map((item: OhsQrCodeRecord) => {
      const qrCodeRecord: OhsQrCodeRecord = {
        ...item,
        subRows: [],
      };

      allocationLists?.map((allocItem: OhsQrCodeRecord) => {
        const { allocationOf } = allocItem;
        if (item._id === allocItem._id) {
          qrCodeRecord.subRows.push(allocItem);
        }
        if (allocationOf && allocationOf._id === item._id) {
          qrCodeRecord.subRows.push(allocItem);
        }
        return null;
      });

      return qrCodeRecord;
    }) as any[];

    const updateQrCodeListwithAllocation = {
      ...qrCodeLists,
      items: qrCodeWithAllocation,
    } as unknown as ApiResListsType<any[]>;

    return updateQrCodeListwithAllocation;
  }
  return null;
};

export default parseListAllocations;
